import { Badge } from '@apps/web/components/ui/badge';
import { statusIntentBadgeClassName } from '@apps/web/components/ui/status_tokens';
import { cn } from '@apps/web/lib/utils';

export type EhrCaregiverStatus = 'active' | 'inactive' | 'applicant';

export const EHR_CAREGIVER_STATUS_OPTIONS: ReadonlyArray<EhrCaregiverStatus> = [
    'active',
    'inactive',
    'applicant',
];

export function formatEhrCaregiverStatus(status: EhrCaregiverStatus): string {
    return status.charAt(0).toUpperCase() + status.slice(1);
}

type EhrCaregiverStatusBadgeProps = {
    readonly status: EhrCaregiverStatus;
    readonly className?: string;
};

export function EhrCaregiverStatusBadge({
    status,
    className,
}: EhrCaregiverStatusBadgeProps) {
    return (
        <Badge
            variant="outline"
            className={cn(
                statusIntentBadgeClassName(
                    status === 'active'
                        ? 'positive'
                        : status === 'applicant'
                          ? 'info'
                          : 'neutral',
                ),
                className,
            )}
        >
            {formatEhrCaregiverStatus(status)}
        </Badge>
    );
}
